export default "__VITE_ASSET__B4dTSQD1__"